import { FuelTableContainer } from 'pages/FuelManagement/FuelManagement.styled'
import styled from 'styled-components'

export const FoodTableContainer = styled(FuelTableContainer)`
  width: 100%;
  height: 100%;
`
export const IngredientsList = styled.div`
  border: ${(props) => props.theme.inputBorder};
  padding: 1rem;
  border-radius: 10px;
  height: 100%;
`
